<p class="fw-bold">
  {{ 'user_edit_overview_l' | translate }}: {{ 'user_birth_date_edit.form_l' | translate }}
</p>

<im-form-field>
  <rs-web-date-picker formControlName="dateOfBirth" label="user_birth_date_edit.form_l" />
</im-form-field>
